import Ben_1 from "../../images/holidayIcons/Ben_1@2x.png";
import Chris from "../../images/holidayIcons/Chris@2x.png";
import Tom from "../../images/holidayIcons/Tom@2x.png";
import Ethel from "../../images/holidayIcons/Ethel@2x.png";
import Leslie from "../../images/holidayIcons/Leslie@2x.png";
import Mark from "../../images/holidayIcons/Mark@2x.png";
import Tammy from "../../images/holidayIcons/Tammy II@2x.png";
import Ron from "../../images/holidayIcons/Ron@2x.png";
import Perd from "../../images/holidayIcons/Perd@2x.png";
import Mona from "../../images/holidayIcons/Mona Lisa@2x.png";

const questions = [
  [
  {
    id: 1,
    inNextQuestionSet: true,
    title: "Ben Wyatt",
    desc: "Ben was just laid off as a state auditor due to budget cuts at the state level. Tax revenue for the state is in decline as unemployment rises due to an economic downturn.",
    answer: "Cyclical",
    icon: Ben_1,
    wrongAnswerText:
      "Not quite! Ben's job loss is the direct result of economic fluctuations, so his unemployment can be categorized as cyclical.",
    rightAnswerText:
      "Great job! Ben's job loss is the direct result of economic fluctuations, so his unemployment can be categorized as cyclical.",
  },
  {
    id: 2,
    inNextQuestionSet: true,
    title: "Chris Traeger",
    desc: "Chris's temporary position as City Manager has come to an end. He is looking for new work in Pawnee.",
    answer: "Frictional",
    icon: Chris,
    wrongAnswerText:
      "Not quite! Chris's job was temporary and was not due to economic fluctuations or a long-term skill mismatch. His unemployment is part of the normal and expected variations in a dynamic economy, making it an example of frictional unemployment.",
    rightAnswerText:
      "Great job! Chris's job was temporary and was not due to economic fluctuations or a long-term skill mismatch. His unemployment is part of the normal and expected variations in a dynamic economy, making it an example of frictional unemployment.",
  },
  {
    id: 3,
    inNextQuestionSet: false,
    title: "Tom Haverford",
    desc: "Tom quits his job as an administrative assistant to pursue his dream of running Entertainment 720 with his friend Jean-Ralphio.",
    answer: "Frictional",
    icon: Tom,
    wrongAnswerText:
      "Not quite! Quitting a job voluntarily to pursue a new business venture is an example of frictional unemployment, and is expected in a dynamic economy as individuals seek to better match their skills with their careers.",
    rightAnswerText:
      "Great job! Quitting a job voluntarily to pursue a new business venture is an example of frictional unemployment, and is expected in a dynamic economy as individuals seek to better match their skills with  their careers.",
  },
  {
    id: 4,
    inNextQuestionSet: true,
    title: "Ethel Beavers",
    desc: "Ethel finds herself without a job after her role as court stenographer is replaced by an AI notetaker. Although she looks for a new role, she never finds a new job as a court stenographer.",
    answer: "Structural",
    icon: Ethel,
    wrongAnswerText: "Not quite! Ethel's skills are made obsolete by a new technology, and her unemployment is long term. This is an example of structural unemployment.",
    rightAnswerText: 
        "Great job! Ethel's skills are made obsolete by a new technology, and her unemployment is long term. This is an example of structural unemployment.",
  },
  {
    id: 5,
    inNextQuestionSet: true,
    title: "Leslie Knope",
    desc: "Leslie loses the election and her City Council seat, leaving her without a job and considering what she should do next.",
    answer: "Frictional",
    icon: Leslie,
    wrongAnswerText:
      "Not quite! Leslie's unemployment is temporary and the result of the expected ups and downs of politics. This is an example of frictional unemployment.",
    rightAnswerText:
      "Great job! Leslie's unemployment is temporary and the result of the expected ups and downs of politics. This is an example of frictional unemployment.",
  },
  {
    id: 6,
    inNextQuestionSet: true,
    title: "Mark Brendanawicz",
    desc: "Mark is laid off from his city planning job due to budget cuts in Pawnee.",
    answer: "Cyclical",
    icon: Mark,
    wrongAnswerText:
      "Not quite! Mark's layoff is attributable to an economic downturn, making it an example of cyclical unemployment.",
    rightAnswerText:
      "Great job! Mark's layoff is attributable to an economic downturn, making it an example of cyclical unemployment.",
  },
  {
    id: 7,
    inNextQuestionSet: false,
    title: "Tammy Swanson II",
    desc: "Tammy II loses her job at the local library as the library shifts to an all digital format. Tammy lacks the technical skills to work in this new version of the library and has been unemployed for over a year.",
    answer: "Structural",
    icon: Tammy,
    wrongAnswerText:
      "Not quite! Tammy's job loss is the result of a technological shift that makes her skillset obsolete. This is an exampe of structural unemployment.",
    rightAnswerText:
      "Great job! Tammy's job loss is the result of a technological shift that makes her skillset obsolete. This is an exampe of structural unemployment.",
  },
  {
    id: 8,
    inNextQuestionSet: true,
    title: "Ron Swanson",
    desc: "Ron quits his job as Director of the Park and Recreation department to avoid working for Councilman Jamm.",
    answer: "Frictional",
    icon: Ron,
    wrongAnswerText:
      "Not quite! Ron quitting his job is an example of typical friction in jobs, and quitting to find a better fit is considered frictional unemployment.",
    rightAnswerText:
      "Great job! Ron quitting his job is an example of typical friction in jobs, and quitting to find a better fit is considered frictional unemployment.",
  },
  {
    id: 9,
    inNextQuestionSet: true,
    title: "Perd Hapley",
    desc: "Perd gets laid off from his job at the local news channel as viewers switch to streaming and other entertainment options. Perd has been a news host since he was a teenager and knows little else, therefore he has struggled to find a new job. ",
    answer: "Structural",
    icon: Perd,
    wrongAnswerText:
      "Not quite! Perd's skills are made obsolete by new technology, and his unemployment is long term. This is an example of structural unemployment.",
    rightAnswerText:
      "Great job! Perd's skills are made obsolete by new technology, and his unemployment is long term. This is an example of structural unemployment.",
  },
  {
    id: 10,
    inNextQuestionSet: true,
    title: "Mona-Lisa Saperstein",
    desc: "Tom fires Mona Lisa from her job at Rent-a-Swag for her unreliable attendance, and unprofessional interactions with customers.",
    answer: "Frictional",
    icon: Mona,
    wrongAnswerText:
      "Not quite! Mona Lisa's firing is an example of fricitional employment. Mona Lisa does not have the right skillset for the role.",
    rightAnswerText:
      "Great job! Mona Lisa's firing is an example of fricitional employment. Mona Lisa does not have the right skillset for the role.",
  }
]
];

export default questions;
